const video = ( $ ) => {
	if($(".shop").is(":visible")){
		$(".video--fancybox").find('.video__image').html("");
		$( ".video--fancybox" ).fancybox({
			padding: 0,
			type: "iframe"
		});
		$(".video--fancybox").unbind("click");
	}else{
		$(document).unbind('click.fb-start');
		$(".video--fancybox").on("click", function(e) {
			e.preventDefault();
			$(".video--fancybox").find('.video__image').html("");
			$(this).find(".video__image").html(createVideoIframe($(this).attr("href")));
		});
	}	
}

const createVideoIframe = (link) => {
	var iframe = document.createElement('iframe');
	iframe.src = link;
	iframe.frameborder = 0;
	return iframe;
}

export default video;
